<template>
  <div class="animated fadeIn">
    <div class="card card-green">
      <div class="card-body">
        <div class="row">
          <div class="card-body table-logoped" v-if="response.root != null">
              <grid
                  :data="response.root"
                  ref="fakturkoGrid"
                  v-model="pagination"
                  :columns="columns"
                  :totalCount="response.totalCount"
                  gridId="fakturkoLogsGrid">
                    <template v-slot="{item, column}">
                        <template v-if="column.id == 'responseStatus'">
                            <span
                                class="badge"
                                :class="item.responseStatus === 'success' ? 'badge-success' : 'badge-danger'">
                                {{item.responseStatus}}
                            </span>
                        </template>
                        <template v-if="column.id == 'actions'">
                            <button
                                type="button"
                                class="btn btn-primary btn-sm button-save"
                                @click="showDetail(item)">
                                {{$t('VIEW')}}
                            </button>
                        </template>
                    </template>
              </grid>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="detailModal" :title="$t('DETAILS')" hide-footer size="xl" no-close-on-backdrop>
      <div class="d-block" v-if="selectedItem">
        <div class="row mb-3">
          <div class="col-md-6">
            <strong>{{$t('ENDPOINT')}}:</strong>
            <p>{{selectedItem.endpoint}}</p>
          </div>
          <div class="col-md-3">
            <strong>{{$t('STATUS')}}:</strong>
            <p>
              <span
                  class="badge"
                  :class="selectedItem.responseStatus === 'success' ? 'badge-success' : 'badge-danger'">
                  {{selectedItem.responseStatus}}
              </span>
            </p>
          </div>
          <div class="col-md-3">
            <strong>{{$t('ATTEMPT')}}:</strong>
            <p>{{selectedItem.attemptNumber}}</p>
          </div>
        </div>
        <div class="row mb-3" v-if="selectedItem.errorMessage">
          <div class="col-12">
            <strong>{{$t('ERRORMESSAGE')}}:</strong>
            <p>{{selectedItem.errorMessage}}</p>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <strong>{{$t('CREATEDAT')}}:</strong>
            <p>{{formatDate(selectedItem.createdAt)}}</p>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <strong>{{$t('REQUESTPARAMS')}}:</strong>
            <pre class="bg-light p-3 rounded">{{formatJson(selectedItem.requestParams)}}</pre>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <strong>{{$t('RESPONSEDATA')}}:</strong>
            <pre class="bg-light p-3 rounded">{{formatJson(selectedItem.responseData)}}</pre>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import Api from '@/api/fakturko/Fakturko';

export default
{
    name: 'FakturkoLogs',
    data()
    {
        const me = this;
        return {
            columns: [
                {
                    key: 'endpoint',
                    name: me.$t('ENDPOINT'),
                },
                {
                    id: 'responseStatus',
                    key: 'responseStatus',
                    name: me.$t('STATUS'),
                    handler()
                    {
                        return '';
                    },
                },
                {
                    key: 'attemptNumber',
                    name: me.$t('ATTEMPT'),
                },
                {
                    key: 'errorMessage',
                    name: me.$t('ERRORMESSAGE'),
                    style: 'max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;',
                },
                {
                    key: 'createdAt',
                    name: me.$t('CREATEDAT'),
                    handler(item)
                    {
                        return moment(item.createdAt).format('DD.MM.YYYY HH:mm:ss');
                    },
                },
                {
                    id: 'actions',
                    name: me.$t('ACTIONS'),
                },
            ],
            response: {},
            selectedItem: null,
            pagination:
            {
                query: '',
                currentPage: 1,
                limit: 25,
                searchTimeout: false,
                sort: 'createdAt',
                dir: 'desc',
            },
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
    {
        async getData()
        {
            const me = this;
            try
            {
                const data = await Api.selectRow(me.getParams);
                if (data.error && data.error === true)
                {
                    me.$notify.notice(data);
                    return;
                }

                me.response = data;
            }
            catch (e)
            {
                me.$notify.notice(e);
            }
        },
        showDetail(item)
        {
            const me = this;
            me.selectedItem = item;
            me.$refs.detailModal.show();
        },
        formatDate(value)
        {
            return moment(value).format('DD.MM.YYYY HH:mm:ss');
        },
        formatJson(value)
        {
            if (!value)
            {
                return '';
            }
            try
            {
                const parsed = typeof value === 'string' ? JSON.parse(value) : value;
                return JSON.stringify(parsed, null, 2);
            }
            catch (e)
            {
                return value;
            }
        },
    },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
    {
        getParams()
        {
            const me = this;
            const data = {
                ...me.pagination,
            };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
    },
};
</script>

<style scoped>
pre {
    max-height: 400px;
    overflow: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
}
</style>
